import  React, { Component } from 'react'
import { $t } from '@/modules/i18n'

export default class ApplyNow extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.markRef = React.createRef();
    this.bannerRef = React.createRef();
    this.onScroll = this.onScroll.bind(this);
    this.state ={
      fix: true,
    }
  }
  componentDidMount() {
    window.addEventListener('scroll', this.onScroll)
  }
  componentWillUnmount() {
    clearTimeout(this.timer)
    window.removeEventListener('scroll', this.onScroll)
  }

  handleFix(status) {
    this.setState({ fix: status });
  }

  onScroll() {
    const markRef = this.markRef && this.markRef.current;
    const bannerRef = this.bannerRef && this.bannerRef.current;
    // console.log('bannerRef', bannerRef);
    clearTimeout(this.timer)
    const fix = this.state.fix;
    this.timer = setTimeout(() => {
      try {
        const bounding = markRef.getBoundingClientRect()
        if (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) - bannerRef.clientHeight
        ) {
          if (fix) {
            this.handleFix(false);
          }
        } else if (!fix) {
          this.handleFix(true);
        }
      } catch (err) { console.error(err); }
    }, 16)
  }

  render() {
    const {
      fix,
    } = this.state;
    return (
      <div className="apply-btn-wrapper">
        <span ref={this.markRef}></span>
        <div  ref={this.bannerRef} className={ !fix ? 'apply-banner apply-banner-nofix': 'apply-banner apply-banner-fix' }>
          <div className="apply-banner-content">
           
            <div className="apply-btn right-btn">
              <a className="right-btn-wrapper" href="https://careers.shopee.sg/jobs?name=Apprentice%20Program&limit=20&offset=0" target="__blank" rel="noopener noreferrer">
                <span className="right-btn-item">{$t('ag_applynow_btn_applynow')}</span>
              </a>
              {/* <a className="right-btn-wrapper" href="https://boards.greenhouse.io/shopee/jobs/5373590002" target="__blank" rel="noopener noreferrer">
                <span className="right-btn-item">{$t('ag_applynow_country_my')}</span>
              </a>
              <a className="right-btn-wrapper" href="http://bit.ly/ShopeeApprenticeID" target="__blank" rel="noopener noreferrer">
                <span className="right-btn-item">{$t('ag_applynow_country_id')}</span>
              </a>
              <a className="right-btn-wrapper" href="https://bit.ly/PHShopeeApprentice" target="__blank" rel="noopener noreferrer">
                <span className="right-btn-item">{$t('ag_applynow_country_ph')}</span>
              </a>
              <a className="right-btn-wrapper" href="http://bit.ly/ShopeeApprenticeTW" target="__blank" rel="noopener noreferrer">
                <span className="right-btn-item">{$t('ag_applynow_country_tw')}</span>
              </a>
              <a className="right-btn-wrapper" href="https://boards.greenhouse.io/shopee/jobs/5344060002" target="__blank" rel="noopener noreferrer">
                <span className="right-btn-item">{$t('ag_applynow_country_th')}</span>
              </a> */}
            </div>
          </div>
          {/* <div className="bg" style={{ top: fix ? 0 : '200px' }}>
            <span className="left"/>
            <span className="right"/>
          </div> */}
        </div>
      </div>
    );
  }
}
